import { Chips, EChipsVariants } from 'components/atoms/Chips';
import React from 'react';
import { ITableColumns, ITableDataSource } from 'models/table';
import { Checkbox } from '@mui/material';
import { ILegalEntityAddress } from 'models/legalEntity';
import { IParsedDictionary } from 'helpers/dictionary';
import Radio from '@mui/material/Radio';

type ISelectLocationTableColumns = {
  handleCheck: (data: ITableDataSource) => void;
  checkedId: string | null;
  t: (key: string) => string;
};

export const SelectLocationTableColumns = ({
  handleCheck,
  checkedId,
  t,
}: ISelectLocationTableColumns): ITableColumns[] => [
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f518',
      key: '',
      title: 'general.select.text',
      isSortable: false,
      align: 'center',
      width: '80px',
      isCenterTableHead: true,
      render: (_data, props) => (
        <Radio
          id="select_address-chechbox-button"
          checked={props.id === checkedId}
          onChange={() => handleCheck(props)}
        />
      ),
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f500',
      key: 'storage',
      title: 'legalEntityDetails.addressTab.storageAddress.column',
      align: 'center',
      isCenterTableHead: true,
      isSortable: false,
      minWidth: '156px',
      render: (_data, props) => (
        <Chips
          text={
            props.storage
              ? t('general.confirmation.yes.button')
              : t('general.confirmation.no.button')
          }
          variant={props.storage ? EChipsVariants.success : EChipsVariants.inactive}
        />
      ),
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f510',
      key: 'typeUniqueId',
      title: 'legalEntityDetails.addressTab.addressType.column',
      align: 'center',
      isCenterTableHead: true,
      isSortable: false,
      render: (_data, props) =>
        props.typeUniqueId ? (
          <Chips text={props.typeUniqueId} variant={EChipsVariants.primary} />
        ) : (
          '-'
        ),
    },

    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f512',
      key: 'line1',
      title: 'legalEntityDetails.addressTab.address.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f513',
      key: 'city',
      title: 'legalEntityDetails.addressTab.city.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f514',
      key: 'regionUniqueId',
      title: 'legalEntityDetails.addressTab.stateProvince.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f515',
      key: 'country',
      title: 'legalEntityDetails.addressTab.country.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f517',
      key: 'postalCode',
      title: 'legalEntityDetails.addressTab.zipPostalCode.column',
      isSortable: false,
    },
    {
      id: 'f0504ca5-6b32-482d-b369-304a6f32f516',
      key: 'gps',
      title: 'legalEntityDetails.addressTab.gps.column',
      isSortable: false,
    },
  ];

export const mapLEAddressToDataSource = (
  items: ILegalEntityAddress[],
  region: IParsedDictionary,
  country: IParsedDictionary,
  type: IParsedDictionary,
  legalEntityId: string,
): ITableDataSource[] =>
  items.map((item) => ({
    id: item.uniqueId,
    typeUniqueId:
      item.typeUniqueId && type?.[item.typeUniqueId] ? type[item.typeUniqueId] : '',
    line1: `${item.line1} ${item.line2}`,
    city: item.city,
    postalCode: item.postalCode,
    regionUniqueId:
      item.regionUniqueId && region?.[item.regionUniqueId] ? region[item.regionUniqueId] : '',
    countryUniqueId: item.countryUniqueId,
    country:
      item.countryUniqueId && country?.[item.countryUniqueId]
        ? country[item.countryUniqueId]
        : '',
    gps: `${item.latitude}, ${item.longitude}`,
    latitude: item.latitude,
    longitude: item.longitude,
    isDefault: item.isDefault,
    storage: item.storage,
    legalEntityId,
  }));
